module.exports = __webpack_public_path__ + "c54e59df2bd27ba9240b1d5ce1c11268.png";